import {
  GET_ADMIN_DASHBOARD_DATA_REQUEST,
  GET_ADMIN_DASHBOARD_DATA_RESPONSE,
} from "./actionTypes";

export const getAdminDashboardDataRequest = () => {
  return {
    type: GET_ADMIN_DASHBOARD_DATA_REQUEST,
  };
};

export const getAdminDashboardDataResponse = (apiResponse) => {
  return {
    type: GET_ADMIN_DASHBOARD_DATA_RESPONSE,
    payload: { apiResponse },
  };
};
